import { Form, Divider, Tabs } from '@bancobarigui/barihaus';
import { Spin } from 'antd';

import { ProtectedRouteContainer } from '@/components/ProtectedRouteContainer';
import { PageHeader } from '@/components/PageHeader';
import { ServiceCheck, FeatureAlert } from '@/shared/components';
import { UserInfoForm } from '@/components/UserInfoForm';
import { RoleTransfer } from '@/components/RoleTransfer';
import { ProvidersTransfer } from '@/components/ProvidersTransfer';
import { RegisterFormButtons } from '@/components/RegisterFormButtons';

import { useProviderUserEdit } from './useProviderUserEdit';

function ProviderUserEditContent() {
  const {
    form,
    loading,
    submitting,
    handleSubmit,
    handleCancel,
  } = useProviderUserEdit();

  if (loading) {
    return (
      <div className="flex justify-center items-center" style={{ minHeight: '400px' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      className="space-y-4"
    >
      <UserInfoForm />

      <Divider>Configurações</Divider>

      <Tabs
        items={[
          {
            key: '1',
            label: 'Perfil de Acesso',
            children: (
              <RoleTransfer module={1} />
            ),
          },
          {
            key: '2',
            label: 'Prestadora',
            children: (
              <ProvidersTransfer />
            ),
          },
        ]}
      />

      <Divider />

      <RegisterFormButtons
        onClickCancel={handleCancel}
        loading={submitting}
      />
    </Form>
  );
}

export function ProviderUserEdit() {
  return (
    <ProtectedRouteContainer
      pageHeader={<PageHeader title="Editar Usuário Prestadora" />}
    >
      <FeatureAlert services={['user']} />
      <ServiceCheck services={['user']} featureName="Edicao de Usuario Prestadora">
        <ProviderUserEditContent />
      </ServiceCheck>
    </ProtectedRouteContainer>
  );
}
